import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { LoanActivityEventDto } from "../dto/active-loan.dto"
import { activeLoanApiService } from "../services/active-loan.service"

export default function useFetchActiveLoanActivity(
  activeLoanId: string | null | undefined,
): UseQueryResult<LoanActivityEventDto[], unknown> {
  const normalizedActiveLoanId = activeLoanId?.trim() ?? ``

  return useQuery({
    queryKey: queryKeys.activeLoan.activity(normalizedActiveLoanId),
    queryFn: () => activeLoanApiService.fetchActivity(normalizedActiveLoanId),
    enabled: normalizedActiveLoanId.length > 0,
    staleTime: 0,
  })
}
